var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-control ui-btn",class:{
    'menu-control--fade': _vm.getShouldFade
  },attrs:{"aria-label":"Show the menu"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('div',{staticClass:"menu-icon-placeholder",class:{
      open: _vm.active
    },attrs:{"id":"bleach-menu-icon"}},[_c('span'),_c('span'),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }